import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { LanguageAbbreviation } from '@/constants/common';
import translation_de from './de';
import translation_en from './en';
import translation_nl from './nl';
import { createTranslationTable, flattenObject } from './until';

const resources = {
  [LanguageAbbreviation.En]: translation_en,
  [LanguageAbbreviation.Nl]: translation_nl,
  [LanguageAbbreviation.De]: translation_de,
};
const enFlattened = flattenObject(translation_en);
const nlFlattened = flattenObject(translation_nl);
const deFlattened = flattenObject(translation_de);
export const translationTable = createTranslationTable(
  [enFlattened, deFlattened, nlFlattened],
  ['English', 'Deutsch', 'Nederlands'],
);
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: {
      lookupLocalStorage: 'lng',
    },
    supportedLngs: Object.values(LanguageAbbreviation),
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
